module.exports = __webpack_public_path__ + "static/townhouse-1342c95cffecfdef0ed4530a4f17eb5b.png";